import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthBootstrap } from "./auth/bootstrap/authbootstrap";
import "./index.css";

function applyThemeFromEnv() {
  const color = process.env.REACT_APP_PRIMARY_COLOR || "#4844D1";
  document.documentElement.style.setProperty("--color-primary", color);
}
applyThemeFromEnv();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthBootstrap>
      <BrowserRouter basename={process.env.REACT_APP_BASE_PATH || ""}>
        <App />
      </BrowserRouter>
    </AuthBootstrap>
  </React.StrictMode>
);
